import { render, staticRenderFns } from "./about-dialog.vue?vue&type=template&id=100897b3&scoped=true&lang=pug&"
import script from "./about-dialog.vue?vue&type=script&lang=ts&"
export * from "./about-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./about-dialog.vue?vue&type=style&index=0&id=100897b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100897b3",
  null
  
)

export default component.exports